module.exports = __webpack_public_path__ + "d808c2e871034951c3e2d971138805a2-clearlaunch_logo_2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/assets/clearlaunch_logo_2x.png
// module id = 253
// module chunks = 0